import React from 'react';
import { useForm, Controller } from 'react-hook-form';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { passwordeye, popUp, singIn } from '../Redux/Auth/AuthSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Notify } from '../CommonPopup/Popup';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import Spinner from '../Spinner/Spinner';
import { checkToken } from '../Redux/Dashboard/DashboardSlice';
import judicialLogo from '../Images/judicialLogo.png';
import '../Style/AdminLogin.css';

const AdminLogin = () => {
  const selector = useSelector((s) => s.AuthSlice);
  const showpassword = selector.showpassword;
  const loader = selector.loader;

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    control,
    handleSubmit,
    reset,
  } = useForm();

  const onSubmit = (data) => {
    reset();
    dispatch(singIn(data))
      .unwrap()
      .then((data) => {
        if (data.success) {
          localStorage.setItem('token', data.token);
          navigate('/dashboard');
          Notify({ data: 'success', msg: data.message });
          dispatch(checkToken(true));
        } else {
          Notify({ data: 'error', msg: data.message });
        }
        setTimeout(() => {
          dispatch(popUp(false));
        }, 5000);
      });
  };

  return (
    <div className="login-main">
      <div className="logo-container">
        <img className="judicial-logo" src={judicialLogo} alt="Judicial Logo" />
      </div>
      <div className="login-container">
        <div className="login-box animate-form">
          <h2 className="login-title">Admin Login</h2>
          {loader ? (
            <div className="spinner-wrapper">
              <Spinner />
            </div>
          ) : (
            <form onSubmit={handleSubmit(onSubmit)} className="login-form">
              <div className="input-group">
                <Controller
                  name="email"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <TextField
                      placeholder="Email"
                      label=""
                      fullWidth
                      variant="outlined"
                      {...field}
                      InputLabelProps={{ shrink: false }}
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          borderRadius: '8px',
                          background: '#ffffff',
                          '& fieldset': { borderColor: '#e5e7eb' },
                          '&:hover fieldset': { borderColor: '#d1d5db' },
                          '&.Mui-focused fieldset': { borderColor: '#3b82f6', boxShadow: '0 0 0 3px rgba(59, 130, 246, 0.2)' },
                        },
                        '& .MuiInputBase-input': {
                          color: '#1f2937',
                        },
                      }}
                    />
                  )}
                />
              </div>
              <div className="input-group password-group">
                <Controller
                  name="password"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <TextField
                      placeholder="Password"
                      label=""
                      type={showpassword ? 'text' : 'password'}
                      fullWidth
                      variant="outlined"
                      {...field}
                      InputLabelProps={{ shrink: false }}
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          borderRadius: '8px',
                          background: '#ffffff',
                          '& fieldset': { borderColor: '#e5e7eb' },
                          '&:hover fieldset': { borderColor: '#d1d5db' },
                          '&.Mui-focused fieldset': { borderColor: '#3b82f6', boxShadow: '0 0 0 3px rgba(59, 130, 246, 0.2)' },
                        },
                        '& .MuiInputBase-input': {
                          color: '#1f2937',
                        },
                      }}
                    />
                  )}
                />
                <FontAwesomeIcon
                  onClick={() => dispatch(passwordeye(!showpassword))}
                  className="password-toggle"
                  icon={showpassword ? faEye : faEyeSlash}
                  aria-label={showpassword ? 'Hide password' : 'Show password'}
                />
              </div>
              <Button
                type="submit"
                variant="contained"
                className="login-button"
                sx={{
                  background: '#3b82f6',
                  borderRadius: '12px',
                  padding: '12px 24px',
                  fontSize: '16px',
                  fontWeight: 600,
                  textTransform: 'none',
                  '&:hover': {
                    background: '#2563eb',
                    boxShadow: '0 4px 12px rgba(59, 130, 246, 0.3)',
                  },
                }}
              >
                Login
              </Button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;